(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/empty-state.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/empty-state.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const EmptyState = _ref => {
  let {
    text = 'Just nu har vi inga odds på den här matchen.'
  } = _ref;
  return React.createElement("section", {
    className: "quick-bets-empty-state"
  }, React.createElement(Icon, {
    color: "fc-navy",
    icon: "odds",
    size: "1000"
  }), React.createElement("p", {
    className: "f-content f-800 f-center"
  }, text));
};
setGlobal('svs.components.oddset.quickBets.EmptyState', EmptyState);

 })(window);